import React from 'react';
import styles from './ConfirmationPopup.module.css';
import IMAGES from '../../assets/images/images';
import { FormFieldLabel as Label, FormErrorLabel as ErrorLabel } from '../label/Labels';
import Asterisk from '../asterisk/Asterisk';
import { TextInput } from '../input/inputs';
import { Formik, useField, Form } from 'formik';
import * as Yup from 'yup';
import { Submit } from '../button/buttons';
import { useState } from 'react';

const FieldWrapper = ({ children }) => {
  return <div className={styles.fieldWrapper}>{children}</div>;
};
const TextField = ({ label, placeholder,maxlength, ...props }) => {
  const [field, meta] = useField(props);
  const hasError = meta.touched && meta.error;
  const inputStyle = hasError ? styles.inputError : null;

  return (
    <FieldWrapper>
      <div>
        <Label text={label} />
        {props?.status !=="Active"?<Asterisk />:<></>}
      </div>
      <TextInput
        {...field}
        {...props}
        placeholder={placeholder}
        style={inputStyle}
      />
      <div style={{display:"flex", justifyContent: hasError?"space-between":"flex-end"}}>
      {hasError ? <ErrorLabel text={meta.error} /> : null}
      {maxlength ?? <label >{maxlength}</label>}
      </div>
    </FieldWrapper>
  );
};

const ConfirmationPopup = ({ onConfirm, onCancel, data = '', header = '',isSubmitActive ,status}) => {
  const validationSchema = Yup.object({
    reason: Yup.string()
      .max(100, "Reason must be at most 100 characters")
      .test(
        "required-if-not-active",
        "Required",
        (value) => {
          if (status === "Active") {
            return true;
          }
          return !!value?.trim();
        }
      )
  });

  return (
    <div className={styles.confirmationpopup}>
      <div className={styles.confirmationpopupcontent}>
        <div className={styles.header}>
          <div className={styles.headertxt}>{header}</div>
          {/* <div><img onClick={onCancel} className={styles.close} src={IMAGES.close} alt="close" /></div> */}
        </div>
        <div className={styles.datatext}>{data}</div>
        <Formik
          initialValues={{ reason: '' }}
          validationSchema={validationSchema}
          onSubmit={(values) =>
            { onConfirm(values.reason)} }
        >
          {({isValid, dirty,values} ) => (
            <Form>
              <TextField
                label="Provide Reason"
                name="reason"
                type="text"
                placeholder="Enter Reason"
                status={status}
                maxlength={`${values?.reason?.length}/100 characters`}
              />
              {/* <div className={styles.limit}>Maximum 100 characters</div> */}
              <div className={styles.buttons}>
                <button type="button" className={styles.cancle} onClick={onCancel}>
                  No, Cancel
                </button>
                <Submit
                  style={styles.submit}
                  title={"Yes, Continue"}
                  isSubmitting={isSubmitActive}
                  disabled={status !=="Active"? !dirty || !isValid:""}
                  />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
